var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgHrSection1TextBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1355.181,
    height: 817.799,
    viewBox: "0 0 1355.181 817.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.826;}.b,.e{fill:#ff7350;}.b,.c{fill-rule:evenodd;}.c,.g{fill:#ebebeb;}.d{fill:#ffe375;}.f{fill:#ffefaf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-9.351 -6.659)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.778,235.212c2.194-2.194,4.4-4.378,6.578-6.583,3.2-3.228,3.212-7.038.013-10.261q-6.154-6.2-12.36-12.358c-3.061-3.034-6.837-3.078-9.865-.087q-6.733,6.656-13.392,13.388c-3.207,3.241-3.2,7.351.019,10.617q5.963,6.046,12.005,12.012c3.15,3.117,7.076,3.136,10.188.078,2.29-2.25,4.543-4.537,6.814-6.806",
    transform: "translate(7 268.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M105.407,56.093c.358,3.015.693,6.031,1.076,9.043,1.256,9.846-4.969,18.318-14.829,20.159A18.1,18.1,0,0,1,70.439,71.827c-.838-3.484-1.286-7.06-1.946-10.59a24.768,24.768,0,0,0-27.752-19.87,49.9,49.9,0,0,1-9.866.771c-7.578-.477-12.568-5.249-14.1-12.892a17.482,17.482,0,0,1,2.01-12.317c2.231-3.823,6.786-6.09,10.87-7.407A68.7,68.7,0,0,1,49.544,6.664a63,63,0,0,1,21.272,3.3,50.34,50.34,0,0,1,30.507,29.28c2.115,5.338,4.219,16.817,4.083,16.852",
    transform: "translate(2.888 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 12.721,
    cy: 12.721,
    r: 12.721,
    transform: "translate(87.016 177.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 17.491,
    cy: 17.491,
    r: 17.491,
    transform: "translate(1196.77 478.452)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 95.405,
    height: 31.802,
    rx: 10,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 1182.432, 150.615)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 143.108,
    height: 31.802,
    rx: 10,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 49.496, 728.493)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 131.977,
    height: 43.993,
    rx: 13.833,
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 1256.423, 712.722)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrSection1TextBg);
export default __webpack_public_path__ + "static/media/hr-section1-text-bg.a4da895a8abd85389811e8b7d3f42f4b.svg";
export { ForwardRef as ReactComponent };